/* =========================================================
   GoldHearted signup UI — V121
   UI only. No analytics.

   Why V121 exists:
   - V112 intentionally hid every signup success block with
     [data-gh-signup-success] { display:none !important; }
     and only showed it when the class gh-signup-success-visible
     was added.
   - V119/V120 began using the HTML hidden property instead, but
     did not add that required class. Result: the form controls were
     hidden after success, while the confirmation stayed hidden too.
     That is the blank box seen in Email Signup / Custom Grillz.
   - V121 restores the required visibility class and adds a
     form-specific return_to query marker so Email, EDU and Grillz
     can identify their own successful redirect reliably.
   - A pageshow fallback covers Shopify CAPTCHA/history restores.
========================================================= */
(function () {
  'use strict';

  var KEY = 'ghSignupUiPendingV121';
  var LEGACY_KEYS = [
    'ghSignupUiPendingV120',
    'ghSignupUiPendingV119',
    'ghSignupUiPendingV117',
    'ghPendingSignupType',
    'ghPendingSignupFormId'
  ];
  var TTL = 30 * 60 * 1000;
  var PAGE_TOKEN = String(Date.now()) + ':' + Math.random().toString(36).slice(2);

  var FORMS = {
    ghGrillzWaitlistForm: 'grillz_waitlist',
    ghXpEmailSignupForm: 'newsletter',
    ghEduInlineSignupForm: 'edu_email_list'
  };

  var HASH_TYPES = {
    'email-signup': 'newsletter',
    ghGrillzWaitlistForm: 'grillz_waitlist',
    ghEduInlineSignupForm: 'edu_email_list'
  };

  var VALID_TYPES = {
    grillz_waitlist: true,
    newsletter: true,
    edu_email_list: true
  };

  function writePending(formId, type) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        formId: formId,
        type: type,
        at: Date.now(),
        pageToken: PAGE_TOKEN,
        path: location.pathname,
        hash: location.hash || ''
      }));
    } catch (e) {}
  }

  function readPending() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      var value = JSON.parse(raw);
      if (!value || !VALID_TYPES[value.type] || !value.at || Date.now() - Number(value.at) > TTL) {
        sessionStorage.removeItem(KEY);
        return null;
      }
      return value;
    } catch (e) {
      return null;
    }
  }

  function clearPending() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    LEGACY_KEYS.forEach(function (key) {
      try { sessionStorage.removeItem(key); } catch (e) {}
    });
  }

  function formForType(type) {
    var formId = Object.keys(FORMS).find(function (id) {
      return FORMS[id] === type;
    });
    return formId ? document.getElementById(formId) : null;
  }

  function clearSuccessNode(node) {
    if (!node) return;
    node.classList.remove('gh-signup-success-visible');
    node.hidden = true;
    node.setAttribute('aria-hidden', 'true');
    node.style.removeProperty('display');
    node.style.removeProperty('visibility');
    node.style.removeProperty('opacity');
  }

  function clearVisualState(form) {
    if (!form) return;
    form.classList.remove('gh-signup-confirmed');

    form.querySelectorAll('[data-gh-signup-success]').forEach(function (node) {
      clearSuccessNode(node);
    });

    form.querySelectorAll('[data-gh-signup-error]').forEach(function (node) {
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
    });
  }

  function resetAllConfirmations() {
    Object.keys(FORMS).forEach(function (formId) {
      clearVisualState(document.getElementById(formId));
    });
    clearPending();
  }

  function cleanSuccessQueryFromUrl() {
    try {
      var url = new URL(window.location.href);
      var changed = false;

      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
        changed = true;
      }
      if (url.searchParams.has('gh_signup')) {
        url.searchParams.delete('gh_signup');
        changed = true;
      }

      if (changed) {
        var clean = url.pathname + (url.search ? url.search : '') + (url.hash || '');
        history.replaceState(history.state, '', clean || '/');
      }
    } catch (e) {}
  }

  function showSuccess(type) {
    var form = formForType(type);
    if (!form) return false;

    clearVisualState(form);

    var success = form.querySelector('[data-gh-signup-success="' + type + '"]');
    if (!success) return false;

    /* V112's CSS uses this class with !important. V119/V120 omitted it,
       which is why the confirmation itself stayed invisible. */
    success.hidden = false;
    success.removeAttribute('aria-hidden');
    success.classList.add('gh-signup-success-visible');

    /* Belt-and-suspenders protection against app/theme CSS loaded later. */
    success.style.setProperty('display', 'block', 'important');
    success.style.setProperty('visibility', 'visible', 'important');
    success.style.setProperty('opacity', '1', 'important');

    form.classList.add('gh-signup-confirmed');

    var email = form.querySelector('input[type="email"]');
    if (email) email.value = '';

    window.setTimeout(function () {
      try { success.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }, 60);

    return true;
  }

  function showError(type) {
    var form = formForType(type);
    if (!form) return false;

    clearVisualState(form);
    var error = form.querySelector('[data-gh-signup-error="' + type + '"]');
    if (!error) return false;

    error.hidden = false;
    error.removeAttribute('aria-hidden');
    return true;
  }

  function hasServerError(type) {
    var form = formForType(type);
    if (!form) return false;
    return !!form.querySelector('[data-gh-signup-error="' + type + '"]');
  }

  function routeMatchesType(type) {
    var hash = (location.hash || '').replace(/^#/, '');
    if (HASH_TYPES[hash] === type) return true;

    var path = String(location.pathname || '').toLowerCase();
    if (type === 'grillz_waitlist' && path === '/pages/custom-grillz') return true;
    if (type === 'edu_email_list' && path === '/pages/goldhearted-edu') return true;
    if (type === 'newsletter' && (path === '/' || path === '')) return true;
    return false;
  }

  function getUrlSignupType() {
    try {
      var type = new URL(location.href).searchParams.get('gh_signup') || '';
      return VALID_TYPES[type] ? type : '';
    } catch (e) {
      return '';
    }
  }

  function evaluateSignupResult(options) {
    options = options || {};

    var pending = readPending();
    var urlType = getUrlSignupType();
    var hash = (location.hash || '').replace(/^#/, '');
    var hashType = HASH_TYPES[hash] || '';
    var sourceType = urlType || (pending && pending.type) || hashType || '';
    if (!sourceType || !VALID_TYPES[sourceType]) return false;

    var posted = false;
    try {
      posted = new URL(location.href).searchParams.get('customer_posted') === 'true';
    } catch (e) {}

    var sourceForm = formForType(sourceType);
    var sourceLiquidPosted = false;
    if (sourceForm) {
      sourceLiquidPosted = !!sourceForm.querySelector('[data-gh-shopify-posted-success="true"]');
    }

    var returnedAfterSubmit = !!(
      pending &&
      routeMatchesType(pending.type) &&
      (
        (pending.pageToken && pending.pageToken !== PAGE_TOKEN) ||
        options.persisted === true
      )
    );

    /* The form-specific gh_signup marker is the strongest signal because it
       is embedded in that exact form's Shopify return_to URL. */
    var confirmed = !!(
      urlType ||
      posted ||
      sourceLiquidPosted ||
      (returnedAfterSubmit && !hasServerError(sourceType))
    );

    if (confirmed) {
      if (showSuccess(sourceType)) {
        clearPending();
        cleanSuccessQueryFromUrl();
        return true;
      }
    } else if (hasServerError(sourceType)) {
      showError(sourceType);
    }

    return false;
  }

  window.GHResetSignupConfirmations = resetAllConfirmations;
  window.GHEvaluateSignupResult = evaluateSignupResult;

  Object.keys(FORMS).forEach(function (formId) {
    var form = document.getElementById(formId);
    if (!form) return;

    clearVisualState(form);
    form.addEventListener('submit', function () {
      clearVisualState(form);
      writePending(formId, FORMS[formId]);
    }, { capture: true });
  });

  /* Normal server redirect / reload path. */
  evaluateSignupResult({ persisted: false });

  /* Shopify CAPTCHA can sometimes return by restoring the original document
     from browser history/BFCache. In that case the script itself does not
     rerun, so pageshow is the reliable place to finish the confirmation. */
  window.addEventListener('pageshow', function (event) {
    if (!event || !event.persisted) return;
    window.setTimeout(function () {
      evaluateSignupResult({ persisted: true });
    }, 0);
  });

  var infoCloseBtn = document.getElementById('infoCloseBtn');
  if (infoCloseBtn) {
    infoCloseBtn.addEventListener('click', function () {
      window.setTimeout(resetAllConfirmations, 0);
    });
  }
})();
